/** Where the signed-in session's token is kept in this browser. */
export const SESSION_KEY = 'soulthread.session';

/** What a session token says about itself; the server still checks every request. */
export function sessionClaims(
  token: string
): { userId?: string; phoneNumber?: string; exp?: number } | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    const parsed = JSON.parse(window.atob(padded)) as Record<string, unknown>;
    return {
      userId: typeof parsed.userId === 'string' ? parsed.userId : undefined,
      phoneNumber: typeof parsed.phoneNumber === 'string' ? parsed.phoneNumber : undefined,
      exp: typeof parsed.exp === 'number' ? parsed.exp : undefined,
    };
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string): boolean {
  const claims = sessionClaims(token);
  return !claims || (claims.exp !== undefined && claims.exp < Math.floor(Date.now() / 1000));
}

/** Whether this browser holds a session that still looks usable. */
export function hasSession(): boolean {
  const token = localStorage.getItem(SESSION_KEY);
  return Boolean(token && sessionClaims(token)?.userId && !isTokenExpired(token));
}
